import { commonEnvironment } from './environment.common';
import { Environment } from './environment.types';

export const environment: Environment = {
  ...commonEnvironment,
  production: false,
  coreUrl: 'https://gestionale.dev.galactus.it',
  apiUrl: '/api',
  gestionaleV1Subdomain: 'gestionale.dev',
  gestionaleV2Subdomain: 'ui.dev',
  name: 'stai su develop'
};
